import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import services from "./services"
import search from './search/search.vue';
import official from 'official';
export default {
    mixins: [services],
    components: {
        search,
        official
    },
    data() {
        return {
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            searchVisiable: false,
            query: {},
            form: this.getFormData(),
            submitform: this.getSubmitForm(),
            dialogVisible: false,
            SchoolPic: [],
            LicencePics: [],
            auditList: [{
                id: "2",
                text: "审核通过"
            }, {
                id: "1",
                text: "审核不通过"
            }],
            rules: {
                AuditStatus: [{
                    required: true,
                    message: "请选择",
                    trigger: "change"
                }],
                AuditOpinion: [{
                    required: true,
                    message: "请填写什么意见",
                    trigger: "blur"
                }]
            },
            tabRadio: '合同审核',
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                AgentCustomerName: "",
                SchoolName: "",
                Tel: "",
                Provinces: "",
                City: "",
                Area: "",
                PrincipalName: "",
                PhoneNo: "",
                Email: "",
                QQ: "",
                Weixin: "",
            });
        },
        getSubmitForm() {
            return cloneDeep({
                Id: "",
                AuditStatus: "",
                AuditOpinion: "",
            });
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        }, //分页监听dd页面
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        getQueryList(val) {
            this.query = val;
            this.getList();
        },
        view(row) {
            this.$nextTick(function () {
                console.log(row)
                this.$refs.myofficial.Regularization({
                    id: row.Id,
                    SchoolId: row.SchoolId,
                    isReadOnly: true,
                    isAuditView: true,
                    OrderId: row.OrderId
                });
            });
        },
        audit(row) {
            // this.submitform.Id = val;
            // var params = {
            //     Sid: this.sysSid,
            //     Session: this.sysSession,
            //     Id: this.submitform.Id
            // };
            // this.getOne(params);
            // this.dialogVisible = true;
            console.log(row)
            this.$nextTick(function () {
                this.$refs.myofficial.Regularization({
                    id: row.Id,
                    SchoolId: row.SchoolId,
                    isReadOnly: true,
                    Audit: true,
                    ApplyType: row.ApplyType,
                    OrderId: row.OrderId
                });
            });
        },
        Submit() {
            if (this.form.AuditStatusName == "待审核" || this.form.AuditStatusName == "未审核通过") {

                let rules = [];
                rules.push({
                    name: "审核信息",
                    value: this.submitform.AuditStatus,
                    required: true
                });
                rules.push({
                    name: "意见内容",
                    value: this.submitform.AuditOpinion,
                    required: true
                });

                let flag = util.checkForm({
                    ele: this,
                    rules: rules
                });

                if (!flag) {
                    return;
                }

                this.CheckSchoolApply(this.submitform);
            }
        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        dialogClose() {
            this.dialogVisible = false;
            this.submitform = this.getSubmitForm();
            this.form = this.getFormData();
        }

    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/checkSchool/vm.js